<template>
  <div class="developer">
    <div class="part-1">
      <div class="main">
        <div class="left">
          <p class="p-1">{{ $t('developer.part1.head1') }}</p>
          <p class="p-2">{{ $t('developer.part1.head2') }}</p>
         <!-- <div class="p-4">
            <a href="/developerapplication">{{ $t('developer.part1.btn1') }}</a>
            <i class="iconfont icon-youjiantou-copy"></i>
          </div>-->
        </div>
        <div class="right">
          <img src="../assets/images/developer-bg-right.png" alt />
        </div>
      </div>
    </div>
    <div class="part-2">
      <div class="main">
        <p class="tit">{{ $t('developer.part2.head') }}</p>
        <p class="tit1">{{ $t('developer.part2.head2') }}</p>
        <div class="content">
          <div class="item">
            <img src="../assets/images/developer-part2-1.png" alt />
            <div class="text">{{$t('developer.part2.text1')}}</div>
            <div class="foot">
              <a v-show="ljcn" href="https://developers.sdchain.io/zhcn/Guides/">{{$t('developer.part2.foot1')}}</a>
              <a  v-show="ljen" href="https://developers.sdchain.io/en/Guides/">{{$t('developer.part2.foot1')}}</a>
              <a v-show="ljft" href="https://developers.sdchain.io/zhtw/Guides/">{{$t('developer.part2.foot1')}}</a>
            </div>
          </div>
          <div class="item">
            <img src="../assets/images/developer-part2-2.png" alt />
            <div class="text">{{$t('developer.part2.text2')}}</div>
            <div class="foot"><a href="/developerapplication"> {{$t('developer.part2.foot2')}}</a></div>
          </div>
          <div class="item">
            <img src="../assets/images/developer-part2-3.png" alt />
            <div class="text">{{$t('developer.part2.text3')}}</div>
            <div class="foot">
              <a v-show="slcn" href="https://developers.sdchain.io/zhcn/Guides/GetStarted.html"> {{$t('developer.part2.foot3')}}</a>
              <a v-show="slen" href="https://developers.sdchain.io/en/Guides/GetStarted.html"> {{$t('developer.part2.foot3')}}</a>
              <a v-show="slft" href="https://developers.sdchain.io/zhtw/Guides/GetStarted.html"> {{$t('developer.part2.foot3')}}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="part-3">
      <div class="main">
        <p class="tit">{{ $t('developer.part3.head') }}</p>
        <p class="tit1">{{ $t('developer.part3.head1') }}</p>
        <div class="content">
          <div class="item">
            <img src="../assets/images/developer-part3-1.png" alt />
            <p>{{ $t('developer.part3.title1') }}</p>
            <ul>
              <li>
                <a  
                 v-show="slcn"
                  href="https://developers.sdchain.io/zhcn/Guides/GetStarted.html"
                >{{ $t('developer.part3.description1') }}</a>
                <a  
               v-show="slen"
                  href="https://developers.sdchain.io/en/Guides/GetStarted.html"
                >{{ $t('developer.part3.description1') }}</a>
                <a  
                 v-show="slft"
                  href="https://developers.sdchain.io/zhtw/Guides/GetStarted.html"
                >{{ $t('developer.part3.description1') }}</a>
              </li>
              <li>
                <a
                v-show="slcn"
                  href="https://developers.sdchain.io/zhcn/Guides/Concepts.html"
                >{{ $t('developer.part3.description2') }}</a>
                <a
                v-show="slen"
                  href="https://developers.sdchain.io/en/Guides/Concepts.html"
                >{{ $t('developer.part3.description2') }}</a>
                <a
                v-show="slft"
                  href="https://developers.sdchain.io/zhtw/Guides/Concepts.html"
                >{{ $t('developer.part3.description2') }}</a>
              </li>
              <li>
                <a
                v-show="slcn"
                  href="https://developers.sdchain.io/zhcn/Guides/Core.html"
                >{{ $t('developer.part3.description3') }}</a>
                 <a
                 v-show="slen"
                  href="https://developers.sdchain.io/en/Guides/Core.html"
                >{{ $t('developer.part3.description3') }}</a>
                 <a
                 v-show="slft"
                  href="https://developers.sdchain.io/zhtw/Guides/Core.html"
                >{{ $t('developer.part3.description3') }}</a>
              </li>
              <li>
                <a
                v-show="slcn"
                  href="https://developers.sdchain.io/zhcn/Guides/SmartContract.html"
                >{{ $t('developer.part3.description4') }}</a>
                 <a
                 v-show="slen"
                  href="https://developers.sdchain.io/en/Guides/SmartContract.html"
                >{{ $t('developer.part3.description4') }}</a>
                 <a
                 v-show="slft"
                  href="https://developers.sdchain.io/zhtw/Guides/SmartContract.html"
                >{{ $t('developer.part3.description4') }}</a>
              </li>
            </ul>
          </div>
          <div class="item">
            <img src="../assets/images/developer-part3-2.png" alt />
            <p>API</p>
            <ul>
              <li>
                <a
                v-show="slcn"
                  href="https://developers.sdchain.io/zhcn/APIReference/API-RPC.html"
                >RPC {{ $t('developer.part3.description11') }}</a>
                   <a
                   v-show="slen"
                  href="https://developers.sdchain.io/en/APIReference/API-RPC.html"
                >RPC {{ $t('developer.part3.description11') }}</a>
                   <a
                   v-show="slft"
                  href="https://developers.sdchain.io/zhtw/APIReference/API-RPC.html"
                >RPC {{ $t('developer.part3.description11') }}</a>
              </li>
              <li>
                <a
                v-show="slcn"
                  href="https://developers.sdchain.io/zhcn/APIReference/API-rest.html"
                >RESTful {{ $t('developer.part3.description11') }}</a>
                  <a
                  v-show="slen"
                  href="https://developers.sdchain.io/en/APIReference/API-rest.html"
                >RESTful {{ $t('developer.part3.description11') }}</a>
                  <a
                  v-show="slft"
                  href="https://developers.sdchain.io/zhtw/APIReference/API-rest.html"
                >RESTful {{ $t('developer.part3.description11') }}</a>
              </li>
              <li>
                <a href="https://github.com/SDChain">SDK</a>
              </li>
              <li>
                <a
                v-show="slcn"
                  href="https://developers.sdchain.io/zhcn/APIReference/Error.html"
                >{{ $t('developer.part3.description12') }}</a>
                <a
                v-show="slen"
                  href="https://developers.sdchain.io/en/APIReference/Error.html"
                >{{ $t('developer.part3.description12') }}</a>
                <a
                v-show="slft"
                  href="https://developers.sdchain.io/zhtw/APIReference/Error.html"
                >{{ $t('developer.part3.description12') }}</a>
              </li>
            </ul>
          </div>
          <div class="item">
            <img src="../assets/images/developer-part3-3.png" alt />
            <p>{{ $t('developer.part3.title3') }}</p>
            <ul>
              <li>
                <a href="https://cable.sdchain.io/">Cable {{ $t('developer.part3.description21') }}</a>
              </li>
              <li>
                <a href="https://github.com/SDChain">GitHub</a>
              </li>
              <li>
                <a href="https://forum.sdchain.io/">{{ $t('developer.part3.description22') }}</a>
              </li>
              <li>
                <a href="https://holographic.sdchain.io">{{ $t('developer.part3.description23') }}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Icon } from "iview";

export default {
  name: "developer",
  data() {
    return {
      ljcn : false,
      ljen :false,
      ljft :false,
      slcn: false,
      slen:false,
      slft:false,

    };
  },

  created() {
    this.getLang();
  },

  methods: {
    getLang() {
        if( localStorage.Lang == "cn"){
          this.ljcn =  true; 
            this.slcn =  true; 
        }else  if( localStorage.Lang == "tw"){
          this.ljft = true;
          this.slft = true;
        }else {
          this.ljen= true;
          this.slen = true;
        }    
    },
  },

  components: {
    Icon
  }
};
</script>

<style lang="less" scoped>
@import url("../assets/css/var.less");
.developer {
  background-color: #ffffff;
  .part-1 {
    height: 600px;
    // background-image: url("../assets/images/developer-bg.jpg");
    background: linear-gradient(
      81deg,
      rgba(12, 116, 245, 1),
      rgba(36, 149, 255, 1)
    );
    background-repeat: no-repeat;
    background-size: 100% 100%;
    .clearfix();
    .left {
      float: left;
      width: 45%;
      padding-top: 220px;
      text-align: left;
      padding-left: 6%;
      vertical-align: middle;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      .p-1 {
        font-size: 66px;
      }
      .p-2 {
        font-size: 22px;
        margin-top: 15px;
        font-weight: 400;
      }

      .p-4 {
        margin-top: 25px;
        width: 222px;
        height: 56px;
        background-color: rgba(245, 245, 245, 1);
        padding: 14px 0 0px 30px;
        a {
          color: rgba(76, 143, 255, 1);
          font-weight: 400;
          //border-radius: 4px;
          font-size: 20px;
        }
        /deep/.iconfont {
          color: rgba(76, 143, 255, 1);
          font-size: 20px;
          margin-left: 5px;
        }
      }
    }
    .right {
      float: left;
      width: 40%;
      text-align: left;
      vertical-align: middle;
      margin-top: 145px;
      margin-left: 60px;
      img{
      }
    }
  }
  .part-2 {
    height: 700px;
    margin-top: 90px;
    .main {
      overflow: hidden;
    }
    .fenge {
      .fgx();
    }
    .tit {
      .part-tit();
      font-size: 30px;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
    }
    .tit1 {
      text-align: center;
      font-size: 20px;
    
      font-weight: 400;
      color: rgba(85, 85, 85, 1);
    }
    .content {
      display: flex;
      margin-top: 80px;
      .item {
        flex: 1;
        margin-right: 15px;
        margin-left: 45px;
        img {
          padding-left: 32px;
          width: 220px;
          height: 170px;
        }
        .text {
          width: 288px;
          height: 168px;
          margin-top: 80px;
          font-size: 16px;
          font-weight: 400;
          line-height: 28px;
          color: rgba(85, 85, 85, 1);
          //text-align: justify;
          text-align: left;
        }
        .foot {
          width: 284px;
          height: 46px;
          text-align: center;
          padding-top: 5px;
          margin-top: 10px;
          border: 1px solid rgba(76, 143, 255, 1);
          font-size: 20px;
          font-weight: 400;
          color: rgba(76, 143, 255, 1);
           cursor: pointer;
        }
        &:hover {
          .foot {
            background-color: rgba(76, 143, 255, 1);
            a{
            color: #ffffff;
            }
          }
        }
      }
    }
  }
  .part-3 {
    height: 840px;
    padding-top: 100px;
    background-color: rgba(243, 246, 251, 1);
    .main {
      overflow: hidden;
      padding-bottom: 10px;
    }
    .fenge {
      .fgx();
    }
    .tit {
      .part-tit();
      font-size: 30px;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
    }
    .tit1 {
      margin-top: 20px;
      text-align: center;
      font-size: 20px;
      font-weight: 400;
      color: rgba(85, 85, 85, 1);
    }
    .content {
      width: 100%;
      margin-top: 60px;
      display: flex;
      .item {
        flex: 1;
        text-align: center;
        margin-left:10px;
        margin-right:20px;
        height: 500px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.05);
        &:hover{
           box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
        }
        img {
          height: 70px;
          width: 70px;
          margin-top: 68px ;
        }
        p {
          margin: 60px 0  20px 0;
          text-align: center;
          font-size: 24px;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
        }
        ul {
          list-style: none;
          li {
            padding: 5px 40px;
            a {
              padding-top:7px ;
              display: block;
              font-size: 20px;
              font-weight: 400;
              color: rgba(85, 85, 85, 1);
              width: 260px;
              height: 46px;
              background: rgba(245, 245, 245, 1);
              &:hover {
                color: #ffffff;
                background: rgba(76, 143, 255, 1);
              }
            }
          }
        }
      }
    }
  }
}
</style>
